var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnd2End(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M104.999 37.2H82.3992C83.0992 34.8 83.4992 32.3 83.4992 29.8C83.4992 28.4 83.3992 27.1 83.1992 25.8H100.899C102.199 25.8 102.999 24.4 102.299 23.3L92.9992 7.3C92.6992 6.8 92.1992 6.5 91.5992 6.5L60.3992 6.6C59.4992 6.5 58.4992 6.5 57.4992 6.5C56.3992 6.5 55.2992 6.5 54.1992 6.6L29.1992 6.7C28.5992 6.7 28.0992 7 27.7992 7.5L18.6992 23.3C18.0992 24.4 18.8992 25.8 20.0992 25.8H64.7992C65.5992 27.4 65.9992 29.3 65.9992 31.3C65.9992 33.3 65.4992 35.2 64.6992 37.3H16.1992C11.7992 37.3 8.19922 41.3 8.19922 46.2V47.6C8.19922 52.5 11.7992 56.5 16.1992 56.5H48.9992C46.7992 58.5 44.4992 60.7 41.8992 63L32.3992 71.6V86.1L93.8992 86.4C94.4992 86.4 95.0992 86.1 95.3992 85.5L103.299 70.3C103.899 69.2 103.099 67.9 101.799 67.9H56.8992V67.7L63.6992 62C65.6992 60.2 67.5992 58.5 69.3992 56.7H104.999C109.399 56.7 112.999 52.7 112.999 47.8V46.4C112.999 41.2 109.399 37.2 104.999 37.2Z",
    fill: "#FFB200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnd2End);
export default __webpack_public_path__ + "static/media/end2end.9986a0dbea15b387c397a422169480b6.svg";
export { ForwardRef as ReactComponent };